export enum EmotionOption {
  HAPPY = '開心',
  SAD = '悲傷',
  ANGER = '生氣',
  FEAR = '害怕',
  DISGUST = '厭惡',
  NEUTRAL = '沒有情緒',
}
